<script setup lang="ts">
const { src } = defineProps<{
    src: string;
}>();
</script>
<template>
    <mr-modal width="auto" mobile-page>
        <div class="container">
            <img :src class="image" alt="image" />
        </div>
    </mr-modal>
</template>
<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .image {
        height: 512px;
        max-height: 100%;
        width: auto;
    }
}
</style>
